import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume16 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="w-full mx-auto my-8 bg-white shadow-md rounded-lg p-6" ref={resumeRef}>
        <header className="text-left mb-8">
          <h1 className="text-4xl font-bold text-[#1b4f72]">
            {ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}
          </h1>
          <h2 className="text-2xl text-[#1b4f72]">
            {ResumeStore?.resumeBuilder.personalDetails.jobTitle}
          </h2>
          <div className="text-sm text-[#1b4f72] mt-2">
            <p>
              {ResumeStore?.resumeBuilder.personalDetails.phone} | {ResumeStore?.resumeBuilder.personalDetails.email} | {ResumeStore?.resumeBuilder.websites[0]?.link}
            </p>
            <p>
              {ResumeStore?.resumeBuilder.personalDetails.city}, {ResumeStore?.resumeBuilder.personalDetails.country}
            </p>
          </div>
        </header>

        <section className="mb-8">
          <h2 className="text-2xl text-[#1b4f72] border-b-2 border-[#bdc3c7] pb-1">Experience</h2>
          {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
            <div key={index} className="mb-6">
              <h3 className="text-xl font-semibold text-[#1b4f72]">{job.jobTitle}</h3>
              <p className="text-sm text-[#1b4f72]">{job.company} | {job.startDate} - {job.endDate} | {job.city}</p>
              <ul className="list-disc pl-5 text-sm text-[#333]">
                {job.description?.split('. ')?.map((desc, idx) => (
                  <li key={idx}>{desc}</li>
                ))}
              </ul>
            </div>
          ))}
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-[#1b4f72] border-b-2 border-[#bdc3c7] pb-1">Education</h2>
          {ResumeStore?.resumeBuilder.education.map((edu, index) => (
            <div key={index} className="mb-6">
              <h3 className="text-xl font-semibold text-[#1b4f72]">{edu.degree}</h3>
              <p className="text-sm text-[#1b4f72]">{edu.school} | {edu.startDate} - {edu.endDate} | {edu.city}</p>
              <p className="text-sm text-[#333]">{edu.description}</p>
            </div>
          ))}
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-[#1b4f72] border-b-2 border-[#bdc3c7] pb-1">Courses</h2>
          {ResumeStore?.resumeBuilder.courses.map((achievement, index) => (
            <div key={index} className="mb-6">
              <p className="text-sm text-[#333]"><strong>{achievement.course}:</strong> {achievement.institution}</p>
            </div>
          ))}
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-[#1b4f72] border-b-2 border-[#bdc3c7] pb-1">Skills</h2>
          <div className="text-sm text-[#333]">
            <p>{ResumeStore?.resumeBuilder.skills.join(', ')}</p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-[#1b4f72] border-b-2 border-[#bdc3c7] pb-1">Languages</h2>
          {ResumeStore?.resumeBuilder.languages.map((language, index) => (
            <div key={index} className="mb-4">
              <p className="text-sm text-[#333]">{language.language} - {language.level}</p>
              <div className="w-full bg-[#ddd] h-2 rounded">
                <div className="bg-[#1b4f72] h-2 rounded" style={{ width: language.level === 'Native' ? '100%' : language.level === 'Proficient' ? '70%' : language.level === 'Advanced' ? '90%' : '50%' }}></div>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  ));
}

export default Resume16;
